import { IFormatServices } from './formats.types'
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import { AppTransformers as transform } from '@/shared/transform'
import { locale } from 'moment';

export class FormatServices implements IFormatServices {

    /** format currency */
    formatCurrency(val, currency, defaultLocale): string {
        return String(utils.formatCurrency(val, currency, defaultLocale));
    }

    /** format currency */
    formatDecimal(val, dec, defaultLocale): string {
        return String(utils.formatDecimal(val, dec, defaultLocale));
    }

    /** format date */
    formatDate(dt): any {
        return utils.formatDate(dt);
    }

    /** format date time */
    formatDateTime(dt): any {
        return utils.formatDateTime(dt);
    }

    /** format to UTC date time */
    formatUTC(dt: any, format?: string) {
        return utils.dateFormat(dt, format);
    }

    formatTitle(title: string) {
        if(title) {
            return title.length > 40 ? `${title.substring(0, 40)}...` : title;
        }
    }
    /** format strings 
     * text: {0} membership will start on {1} and expire on {2} 
     * replacementArray: ['Jamie\'s', '11/27/14',  '11/27/15']
     * */
    personalizeString(text: string, replacementArray: string[]) {
        return text.replace(/({\d})/g, function(j) { 
            return replacementArray[j.replace(/{/, '').replace(/}/, '')];
        });

    }

    /** format to UTC date time */
    formatPercentage(value, includePercentage = true, locale) {
        value = Math.round((Number(value) + Number.EPSILON) * 100) / 100

        if ( [null, undefined, '', NaN].includes(value)  ) {
            return ''  
        }

        value = new Intl.NumberFormat(locale, {
            style: 'decimal',        
            minimumFractionDigits: 2
        }).format(value);
        
        return includePercentage ? `${value}%` : `${value}`;
    }
   
    formatCurrencyRound = (value, currency, locale) => {
        if ( [null, undefined, '', NaN].includes(value)  ) {
            return ''  
        }
        return Intl.NumberFormat(locale, { 
            style: 'currency', 
            currency: currency || 'EUR',
            minimumFractionDigits: 2
        }).format(value);
    }
}